/**
 * Партнёрская ссылка: ?ref= или ?partner= на сайте платформы.
 * Last-touch: новый код в адресе заменяет сохранённый. Живёт 90 дней.
 */

const STORAGE_KEY = "bs_partner_ref";
const COOKIE_NAME = "bs_partner_ref";
const TTL_MS = 90 * 24 * 60 * 60 * 1000;

function getCookieDomain() {
  const base = (process.env.REACT_APP_BASE_DOMAIN || "").trim().toLowerCase();
  if (!base || base === "localhost") return "";
  return `;domain=.${base}`;
}

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}=([^;]*)`),
  );
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name, value, maxAgeSec) {
  if (typeof document === "undefined") return;
  const secure =
    typeof window !== "undefined" && window.location?.protocol === "https:"
      ? ";Secure"
      : "";
  document.cookie = `${name}=${encodeURIComponent(value)};path=/${getCookieDomain()};max-age=${maxAgeSec};SameSite=Lax${secure}`;
}

export function normalizePartnerCode(raw) {
  const code = String(raw || "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
  if (code.length < 4 || code.length > 16) return "";
  return code;
}

function parseStored(raw) {
  if (!raw) return "";
  try {
    const data = JSON.parse(raw);
    if (!data?.code) return "";
    if (data.expiresAt && Date.now() > Number(data.expiresAt)) return "";
    return normalizePartnerCode(data.code);
  } catch {
    return "";
  }
}

export function getPartnerCode() {
  if (typeof window === "undefined") return "";
  try {
    const fromLs = parseStored(localStorage.getItem(STORAGE_KEY));
    if (fromLs) return fromLs;
  } catch {
    /* private mode */
  }
  return parseStored(readCookie(COOKIE_NAME));
}

export function capturePartnerRef(raw) {
  const code = normalizePartnerCode(raw);
  if (!code || typeof window === "undefined") return "";
  const payload = JSON.stringify({
    code,
    expiresAt: Date.now() + TTL_MS,
  });
  try {
    localStorage.setItem(STORAGE_KEY, payload);
  } catch {
    /* ignore */
  }
  writeCookie(COOKIE_NAME, payload, Math.floor(TTL_MS / 1000));
  return code;
}

export function capturePartnerRefFromSearch(search = "") {
  const params = new URLSearchParams(search || "");
  const raw = params.get("ref") || params.get("partner") || "";
  if (!raw) return getPartnerCode();
  return capturePartnerRef(raw);
}
